import { useSelector } from 'react-redux'

import { useGetMayMentalHealthCustomMessages as useGetMayMentalHealthCustomMessagesShared } from '@lyrahealth-inc/shared-app-logic/src/features/CMSMicrosite/hooks/useGetMayMentalHealthCustomMessages'

import {
  getIsCustomerHPIExclusive,
  getNumberOfSessions,
  getNumberOfSessionsByProgram,
} from '../../../data/customer/customerSelectors'

export const useGetMayMentalHealthCustomMessages = () => {
  const numSessions = useSelector(getNumberOfSessions)
  const numberOfSessionByProgram = useSelector(getNumberOfSessionsByProgram)
  const isHPIExclusive = useSelector(getIsCustomerHPIExclusive)

  return useGetMayMentalHealthCustomMessagesShared({
    numSessions,
    numberOfSessionByProgram,
    isHPIExclusive,
  })
}
